import SynthiAiLogo from '@/common/images/SynthiAi.png';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	Wrapper,
	LeftInfo,
	SynthiAiLogoWrapper,
	Title,
	PriceWrapper,
	PlanName,
	SaveWrapper,
	TextWrapper,
	Text,
	PriceInfoWrapper,
	Border,
	ActionWrapper,
} from '../OneOffFastSpringPayment.styles';
import Loading from '@/common/components/Loading';
import usePlanHook from './hooks/usePlanHook';

const Plans = () => {
  const translations = useLanguageData('checkout');
	const { isLoading, handleChangeSelect, pricesData, promo, selectedOption}= usePlanHook()
	
	return (
		<>
			{(isLoading) && <Loading />}
			<Wrapper>
				<LeftInfo>
					<SynthiAiLogoWrapper>
						<img src={SynthiAiLogo} />
					</SynthiAiLogoWrapper>
					<Title>{translations.leftTitle}</Title>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						<div style={{ minWidth: '320px' }}>
							{[...pricesData]
								.sort((a, b) => b.full_price - a.full_price)
								.map((pd,i) => (
								<PriceWrapper style={{ marginBottom: '12px'}} key={i}  >
										<div
											style={{
												display: 'flex',
												gap: '22px',
												width: 'fit-content',
											}}
										>
											<input
												type='radio'
												id={pd._id}
												value={pd._id}
												name='plan'
												checked={pd._id === selectedOption?._id}
												onChange={() => handleChangeSelect(pd)}
												style={{
													cursor: "pointer"
												}}
											/>
											<span
												class='custom-radio-button'
												style={{ marginTop: '5px' }}
											></span>
											<label
												htmlFor={pd._id}
												style={{
													display: 'flex',
													gap: '22px',
												}}
											>
												<PlanName
													style={{
														color:
															pd._id === selectedOption?._id
																? 'linear-gradient(10deg, #48068A 10%, #4322C6 65%)'
																: '#29185E',
													}}
												>
													{pd.inAppPrice.label}
												</PlanName>{' '}
												<SaveWrapper promo={promo}>
													{promo
														? pd.inAppPrice.promo_saving
														: pd.inAppPrice.saving}
												</SaveWrapper>{' '}
											</label>
										</div>
										{pd._id === selectedOption?._id && (
											<PriceInfoWrapper>
												<TextWrapper>
													<Text>{pd.inAppPrice.full_label}</Text>
													<Text>{pd.inAppPrice.orginal_full_price}</Text>
												</TextWrapper>
												<TextWrapper>
													<Text>
														{promo
															? pd.inAppPrice.promo_discount_label
															: pd.inAppPrice.discount_label}
													</Text>
													<Text
														style={{
															color: `${
																promo ? '#149069' : 'var(--pink, #E94F96)'
															}`,
														}}
													>
														{promo
															? pd.inAppPrice.promo_discount_value
															: pd.inAppPrice.discount_value}
													</Text>
												</TextWrapper>
												<Border />
												<TextWrapper>
													<Text>{translations.total}</Text>
													<Text>
														<b>
															{' '}
															{promo ? pd.promo_full_price : pd.full_price}{' '}
															{translations.currencySign}
														</b>
													</Text>
												</TextWrapper>
											</PriceInfoWrapper>
										)}
									</PriceWrapper>
								))}
						</div>
					</div>
				</LeftInfo>
				<ActionWrapper >
				<div id="fsc-embedded-checkout-container"  autoFocus ></div>
				</ActionWrapper>
			</Wrapper>

		</>
	);
};

export default Plans;
